<template>
  <div class="lylytime">
    <Input
      ref="yearInput"
      style="width:50px"
      v-model="year"
      @on-focus="handleFocus('year')"
      @on-change="handleYearInput"
      @on-blur="fixYear"
      @keydown.native="handleKeySwitch('year', $event)"
      maxlength="4"
    />
    <span>-</span>
    <Input
      ref="monthInput"
      style="width:30px"
      v-model="month"
      @on-focus="handleFocus('month')"
      @on-change="handleMonthInput"
      @on-blur="fixMonth"
      @keydown.native="handleKeySwitch('month', $event)"
      maxlength="2"
    />
    <span>-</span>
    <Input
      ref="dateInput"
      style="width:30px"
      v-model="date"
      @on-focus="handleFocus('date')"
      @on-change="handleDateInput"
      @on-blur="fixDate"
      @keydown.native="handleKeySwitch('date', $event)"
      maxlength="2"
    />
  </div>
</template>

<script>
export default {
  model: {
    prop: "value",
    event: "input"
  },
  props: {
    value: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      year: "",
      month: "",
      date: "",
      innerEmitNull: false
    };
  },
  watch: {
    value: {
      handler(val) {
        if (this.innerEmitNull) {
          this.innerEmitNull = false;
          return;
        }
        if (!val || val === "") {
          this.year = "";
          this.month = "";
          this.date = "";
          return;
        }
        const d = new Date(val);
        if (isNaN(d.getTime())) {
          this.year = "";
          this.month = "";
          this.date = "";
          return;
        }
        this.year = String(d.getFullYear());
        this.month = String(d.getMonth() + 1).padStart(2, "0");
        this.date = String(d.getDate()).padStart(2, "0");
      },
      immediate: true
    }
  },
  methods: {
    isAllFilled() {
      return !!this.year && !!this.month && !!this.date;
    },

    emitTimeStamp() {
      if (!this.isAllFilled()) {
        this.innerEmitNull = true;
        this.$emit("input", null);
        return;
      }
      const y = Number(this.year);
      const m = Number(this.month);
      const d = Number(this.date);
      if (String(y).length !== 4 || m < 1 || m > 12 || d < 1 || d > 31) {
        this.innerEmitNull = true;
        this.$emit("input", null);
        return;
      }
      const target = new Date(y, m - 1, d);
      if (
        target.getFullYear() !== y ||
        target.getMonth() + 1 !== m ||
        target.getDate() !== d
      ) {
        this.innerEmitNull = true;
        this.$emit("input", null);
        return;
      }
      this.$emit("input", target.getTime());
    },

    handleFocus(type) {
      this.$nextTick(() => {
        const dom = this.$refs[`${type}Input`].$refs.input;
        dom.select();
      });
    },

    handleKeySwitch(type, e) {
      const order = ["year", "month", "date"];
      const curIndex = order.indexOf(type);
      let targetType = null;
      if (e.key === "ArrowRight") {
        if (curIndex < order.length - 1) targetType = order[curIndex + 1];
      } else if (e.key === "ArrowLeft") {
        if (curIndex > 0) targetType = order[curIndex - 1];
      }
      if (targetType) {
        e.preventDefault();
        this.$nextTick(() => {
          const targetDom = this.$refs[`${targetType}Input`].$refs.input;
          targetDom.focus();
          targetDom.select();
        });
      }
    },

    handleYearInput() {
      this.year = this.year.replace(/[^\d]/g, "");
      if (this.year.length === 4) {
        this.$nextTick(() => {
          const inputDom = this.$refs.monthInput.$refs.input;
          inputDom.focus();
          inputDom.select();
        });
      }
    },
    fixYear() {
      this.year = this.year.replace(/[^\d]/g, "").slice(0, 4);
      this.emitTimeStamp();
    },

    // 修复：输入月份时实时限制最大值12，无法输入71、99
    handleMonthInput() {
      this.month = this.month.replace(/[^\d]/g, "");
      const num = Number(this.month);
      // 只要数字大于12，直接固定为12，杜绝非法月份展示
      if (num > 12) {
        this.month = "12";
      }
      if (this.month.length === 2 && num >= 1 && num <= 12) {
        this.$nextTick(() => {
          const inputDom = this.$refs.dateInput.$refs.input;
          inputDom.focus();
          inputDom.select();
        });
      }
    },
    fixMonth() {
      if (!this.month) {
        this.emitTimeStamp();
        return;
      }
      let num = Number(this.month);
      num = Math.max(1, Math.min(12, num));
      this.month = num.toString().padStart(2, "0");
      this.emitTimeStamp();
    },

    getMonthMaxDay(y, m) {
      const monthDays = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
      if (m === 2 && ((y % 4 === 0 && y % 100 !== 0) || y % 400 === 0)) {
        return 29;
      }
      return monthDays[m - 1] || 31;
    },

    handleDateInput() {
      this.date = this.date.replace(/[^\d]/g, "");
      if (!this.isAllFilled()) return;
      const y = Number(this.year);
      const m = Number(this.month);
      const maxDay = this.getMonthMaxDay(y, m);
      const day = Number(this.date);
      if (day > maxDay) this.date = String(maxDay);
    },

    fixDate() {
      this.date = this.date.replace(/[^\d]/g, "");
      if (this.isAllFilled()) {
        const y = Number(this.year);
        const m = Number(this.month);
        const maxDay = this.getMonthMaxDay(y, m);
        let day = Number(this.date);
        day = Math.max(1, Math.min(maxDay, day));
        this.date = day.toString().padStart(2, "0");
      }
      this.emitTimeStamp();
    }
  }
};
</script>

<style scoped>
.lylytime {
  display: flex;
  align-items: center;
  gap: 4px;
}
</style>



// WEBPACK FOOTER //
// ../common/src/components/lyTime.vue